import type {
  MaterialCaptureUnit,
  MaterialPresentationType,
} from '../materials-catalog/index.js';

export const materialCategorySourceValues = ['station', 'company', 'catalog'] as const;
export type MaterialCategorySource = (typeof materialCategorySourceValues)[number];

export const materialCategoryRuleTypeValues = ['presentationTypes', 'unit', 'crvEligible'] as const;
export type MaterialCategoryRuleType = (typeof materialCategoryRuleTypeValues)[number];

export type MaterialCategoryRule =
  | {
      type: 'presentationTypes';
      presentationTypes: MaterialPresentationType[];
    }
  | {
      type: 'unit';
      unit: MaterialCaptureUnit;
    }
  | {
      type: 'crvEligible';
      isCrvEligible: boolean;
    };

export interface MaterialCategoryMember {
  materialId: string;
  presentationType: MaterialPresentationType;
}

export interface MaterialCategoryDto {
  id: string;
  companyId: string;
  stationId: string | null;
  name: string;
  sortOrder: number;
  isActive: boolean;
  rule: MaterialCategoryRule | null;
  createdAt: string;
  updatedAt: string;
}

export interface MaterialCategoryWithMembersDto extends MaterialCategoryDto {
  members: MaterialCategoryMember[];
}

export interface ResolvedMaterialCategoryDto {
  id: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
  source: MaterialCategorySource;
  members: MaterialCategoryMember[];
}

export interface ListMaterialCategoriesRequest {
  companyId: string;
  stationId?: string | null;
}

export interface ListMaterialCategoriesResponse {
  items: MaterialCategoryWithMembersDto[];
}

export interface MaterialCategoryInput {
  id: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
  rule?: MaterialCategoryRule | null;
}

export interface UpsertMaterialCategoriesRequest {
  companyId: string;
  stationId?: string | null;
  categories: MaterialCategoryInput[];
}

export interface UpsertMaterialCategoriesResponse {
  items: MaterialCategoryDto[];
}

export interface ReplaceMaterialCategoryMembersRequest {
  companyId: string;
  categoryId: string;
  stationId?: string | null;
  members: MaterialCategoryMember[];
}

export interface ReplaceMaterialCategoryMembersResponse {
  category: MaterialCategoryWithMembersDto;
}

export interface ResolveMaterialCategoriesRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  effectiveOn?: string;
  includeInactive?: boolean;
}

export interface ResolveMaterialCategoriesResponse {
  items: ResolvedMaterialCategoryDto[];
}
